import * as Sentry from '@sentry/react';

export function wsLog(kind: string, data: Record<string, any> = {}) {
  Sentry.addBreadcrumb({
    category: 'ws',
    level: kind === 'close' || kind === 'error' ? 'warning' : 'info',
    message: kind,
    data,
  });
}
